<div class="footer">
    情報系荷物運搬便システム
</div>